import React from "react";
import PropTypes from "prop-types";
import UserAttributesForm from "../UserAttributesForm";

export const DIALOG_TITLE = "My Account";

const MyAccountForSSO = ({
  isOpen,
  setIsOpen,
  editableAttributes,
  attributes,
}) => {
  const isInputEditable = (name) =>
    !attributes?.[name]?.trim() || editableAttributes?.includes(name);

  const isSelectEditable = () => true;

  const hideDialog = () => {
    setIsOpen(false);
  };

  return (
    <UserAttributesForm
      isOpen={isOpen}
      attributes={attributes}
      isInputEditable={isInputEditable}
      isSelectEditable={isSelectEditable}
      handleSubmit={hideDialog}
      title={DIALOG_TITLE}
      doesTitleHaveBorder={false}
      hasCloseButton={true}
      handleClose={hideDialog}
      onRequestClose={hideDialog}
    />
  );
};

MyAccountForSSO.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  editableAttributes: PropTypes.arrayOf(PropTypes.string),
  attributes: PropTypes.object.isRequired,
};
export default MyAccountForSSO;
